import { get, map, last } from 'lodash';
import { createSelector } from 'reselect';
import { MODAL_TYPE_POST_SETTINGS } from '@wix/communities-blog-client-common/dist/src/constants/modal-types';

const getModalState = state => state.modal;
const getById = state => getModalState(state).byId;
export const getIdList = state => getModalState(state).idList;

const getModalCount = state => getIdList(state).length;
export const isModalDisplayed = state => Boolean(getModalCount(state));

export const getModal = (state, id) => getById(state)[id];
export const getModalMeta = (state, id) => get(getModal(state, id), 'meta', {});

export const getLastModalType = state => last(getIdList(state));

export const getModals = createSelector(
  [getById, getIdList],
  (byId, idList) => map(idList, id => byId[id]),
);

export const getPostSettingsModalProps = state => get(getModal(state, MODAL_TYPE_POST_SETTINGS), 'props', {});
